import { render, staticRenderFns } from "./GhostLogin.vue?vue&type=template&id=0b0275b0&scoped=true"
import script from "./GhostLogin.vue?vue&type=script&lang=js"
export * from "./GhostLogin.vue?vue&type=script&lang=js"
import style0 from "./GhostLogin.vue?vue&type=style&index=0&id=0b0275b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b0275b0",
  null
  
)

export default component.exports